import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DEPRECATED_TextInput, FormField, Txt, useTranslations } from "@jti/ui";
import { FormFields } from "../../../constants/checkout-constants";
import styles from "./OrderAttributeTextInput.module.scss";
const createRegExpFromString = (str) => {
    try {
        return new RegExp(str);
    }
    catch (error) {
        console.error("no valid RegExp for ", str);
        return null;
    }
};
export const OrderAttributeTextInput = ({ orderAttribute }) => {
    const { __ } = useTranslations();
    const fieldRegex = createRegExpFromString(orderAttribute.validate_regex);
    const patternRules = orderAttribute.validate_regex && fieldRegex
        ? {
            pattern: {
                value: fieldRegex,
                message: __("form_validation.validate_regex"),
            },
            valueAsNumber: false,
        }
        : {
            valueAsNumber: orderAttribute.numeric,
        };
    return (_jsxs("div", { className: styles.orderAttribute, "data-testid": "order-attribute-text-input", children: [_jsx(FormField, { id: orderAttribute.code, label: orderAttribute.label, name: `${FormFields.OrderAttributes}.${orderAttribute.code}`, defaultValue: orderAttribute.value || "", className: styles.field, render: ({ field }) => (_jsx(DEPRECATED_TextInput, { ...field, dataTestId: `${FormFields.OrderAttributes}-${orderAttribute.code}`, placeholder: orderAttribute.placeholder || "" })), validation: {
                    ...(orderAttribute.is_required && {
                        required: {
                            value: orderAttribute.is_required,
                            message: __("form_validation.field_required"),
                        },
                    }),
                    ...(orderAttribute.min_length && {
                        minLength: {
                            value: orderAttribute.min_length,
                            message: __("form_validation.min_length", [orderAttribute.min_length]),
                        },
                    }),
                    ...(orderAttribute.max_length && {
                        maxLength: {
                            value: orderAttribute.max_length,
                            message: __("form_validation.max_length", [orderAttribute.max_length]),
                        },
                    }),
                    ...patternRules,
                } }), orderAttribute.description && (_jsx(Txt, { variant: "small-text", dataTestId: `${orderAttribute.code}-description`, as: "span", children: orderAttribute.description }))] }));
};
//# sourceMappingURL=OrderAttributeTextInput.js.map